export default __webpack_public_path__ + "static/media/applications-image-10.3217b5bb.jpg";